
import { UserCog, CreditCard, LogOut } from "lucide-react";
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

interface SettingsMenuItemsProps {
  onProfileClick: () => void;
  onSubscriptionClick: () => void;
  onSignOut: () => void;
}

export const SettingsMenuItems = ({
  onProfileClick,
  onSubscriptionClick,
  onSignOut,
}: SettingsMenuItemsProps) => {
  return (
    <>
      <DropdownMenuItem onClick={onProfileClick} className="gap-2">
        <UserCog className="h-4 w-4" />
        Edit Profile
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onSubscriptionClick} className="gap-2">
        <CreditCard className="h-4 w-4" />
        Manage Subscription
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onSignOut} className="gap-2">
        <LogOut className="h-4 w-4" />
        Sign Out
      </DropdownMenuItem>
    </>
  );
};
